import styled, { keyframes } from "styled-components";
import { COLORS } from "../../assets/colors";
import mixins from "../../mixins";
import carpoolBg from "../../assets/carpool_bg.png";
const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(50%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const PageWrapper = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: row;
  background: url(${carpoolBg}) no-repeat center center fixed;
  background-size: cover;
  
  @media (max-width: 600px) {
    flex-direction: column;
    padding-bottom: 4rem;
  }
`;

export const Header = styled.header`
  height: 80px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
`;

export const Sider = styled.aside`
  width: 200px;
  background-color: #f5f5f5;
  padding: 20px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
export const Content = styled.div`
  flex: 4;
  .container {
    max-width: 864px;
    margin: auto;
  }
  .headerText {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 2rem;
    width: 100%;
    background: transparent;
    height: fit-content;
    gap: 1rem;
    
    @media (max-width: 546px) {
      height: auto;
    }
    
    h1 {
      color: #054752;
      font-weight: 700;
      font-size: 2rem; 
      
      @media (max-width: 546px) {
        font-size: 24px;
      }
    }
    
    p {
      color: #64748b;
      margin-top: 8px;
    }
    
    .tabs {
      height: auto;
      width: fit-content;
      display: flex;
      gap: 0.5rem;
      background: rgba(255, 255, 255, 0.4);
      padding: 0.5rem;
      border-radius: 50px;
      backdrop-filter: blur(5px);
      
      @media (max-width: 546px) {
        padding: 0.5rem;
        width: 100%;
        overflow-x: auto;
        border-radius: 12px;
      }
      
      .active {
        background: #054752;
        color: white;
        box-shadow: 0 4px 6px rgba(5, 71, 82, 0.2);
        border: none;
      }
      
      div {
        height: 2.5rem;
        cursor: pointer;
        padding: 0 1.5rem;
        background: transparent;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #64748b;
        border-radius: 50px;
        margin: 0;
        font-weight: 600;
        transition: all 0.2s ease;
        
        :hover {
          color: #054752;
          background: rgba(255, 255, 255, 0.5);
        }
        
        &.active:hover {
          background: #054752;
          color: white;
        }

        @media (max-width: 546px) {
          padding: 0 1rem;
          white-space: nowrap;
        }
      }
    }
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;
  padding: 20px;
  .pagination {
    margin: 2rem 0;
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const CardWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 20px;
  .view-link {
    text-decoration: none;
    color: ${COLORS.primaryColor};
    font-size: 1rem;
    font-weight: 500;
  }
`;

export const Card = styled.div`
  transition: all 0.3s ease;
  background: var(--card-bg);
  backdrop-filter: blur(var(--glass-blur));
  width: 48%;
  margin-bottom: 20px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  animation: jWuYRJ 0.5s ease-in-out;
  animation: ${fadeIn} 0.5s ease-in-out;
  overflow: hidden;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    border-color: #054752;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    
    .title-container {
      display: flex;
      align-items: center;
      width: 100%;
      background: rgba(5, 71, 82, 0.05);
      border-bottom: 1px solid rgba(5, 71, 82, 0.1);
      padding: 1rem;
      justify-content: center;
      gap: 1rem;
      
      h3 {
        color: #054752;
        font-size: 1.1rem;
        font-weight: 700;
      }
      
      p {
        color: #64748b;
        font-size: 0.9rem;
        margin-top: 0.25rem;
      }
      
      img {
        filter: opacity(0.6);
      }
    }

    h3 {
      color: black;
      svg {
        margin-bottom: -3px;
        fill: black;
      }
    }
    .view-link {
      text-decoration: underline;
    }
  }
  .card-body {
    display: flex;
    justify-content: space-between;
    padding: 1.5rem;
    
    .link-container {
      width: 100%;
      flex-direction: column;
      align-items: flex-end;
      display: flex;
      gap: 0.75rem;
      justify-content: center;
      margin-top: 0;
      
      a {
        text-decoration: none;
        color: #054752;
        font-weight: 600;
        font-size: 0.9rem;
        transition: all 0.2s;
        
        :hover {
          color: #00bfa5;
        }
        
        &.link {
           /* Specific styles for message/details links if needed */
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const CardTitle = styled.h3`
  font-size: 18px;
  margin-bottom: 10px;
`;

export const CardDate = styled.div`
  font-size: 14px;
  margin-bottom: 5px;
  color: ${COLORS.secondaryColor};
  display: flex;
  flex-direction: column;
  span {
    color: ${COLORS.secondaryTextColor};
  }
`;

export const CardStatus = styled.div`
  font-size: 14px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;

  span {
    color: ${COLORS.secondaryTextColor};
    font-weight: normal;
  }
  color: ${({ isComplete }) => (isComplete ? "gray" : "inherit")};
`;

export const CardButton = styled.button`
  display: block;
  padding: 0.5rem 1rem;
  border: 1px solid #ef4444;
  border-radius: 8px;
  background: transparent;
  color: #ef4444;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 1rem;

  &:hover {
    background-color: #ef4444;
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(239, 68, 68, 0.2);
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: ${COLORS.primaryColor};
  color: white;
  padding: 1rem;
  h4 {
    color: white;
    font-size: 1.5rem;
    border-bottom: 1px solid;
  }
  ul {
    @media (max-width: 600px) {
      display: flex;
    }
  }
`;

export const Tab = styled.div`
  padding: 10px;
  cursor: pointer;
  font-size: 18px;
  color: ${({ active }) => (active ? `${COLORS.primaryColor}` : "normal")};
  font-weight: ${({ active }) => (active ? "bold" : "normal")};
  border-bottom: ${({ active }) =>
    active ? `2px solid ${COLORS.primaryColor}` : "none"};
`;
